import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
} from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';

const WorkOrdersSection = ({ workOrders }) => {
  const [activeTab, setActiveTab] = useState(0);

  const filteredOrders =
    activeTab === 0
      ? workOrders
      : activeTab === 1
      ? workOrders.filter((wo) => wo.status !== 'Completed')
      : workOrders.filter((wo) => wo.status === 'Completed');

  return (
    <Card sx={{ borderRadius: 1, mb: 3 }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AssignmentIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
              Work Orders
            </Typography>
          </Box>

          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            sx={{
              minHeight: 32,
              '& .MuiTab-root': {
                minHeight: 32,
                py: 0.5,
                px: 1.5,
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'none',
                color: '#6B7280',
              },
              '& .Mui-selected': { color: '#1B2A3D', fontWeight: 600 },
              '& .MuiTabs-indicator': { bgcolor: '#1B2A3D', height: 2 },
            }}
          >
            <Tab label="All" />
            <Tab label="Outstanding" />
            <Tab label="History" />
          </Tabs>
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {['Work Order', 'Title', 'Status', 'Priority', 'Assigned To', 'Due Date'].map(
                  (header) => (
                    <TableCell
                      key={header}
                      sx={{
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: '#6B7280',
                        borderBottom: '1px solid #E5E7EB',
                        py: 1.25,
                      }}
                    >
                      {header}
                    </TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.map((wo) => (
                <TableRow key={wo.id} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                  <TableCell sx={{ fontSize: '0.8125rem', color: '#1B2A3D', fontWeight: 500, py: 1.5 }}>
                    {wo.id}
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.8125rem', color: '#1B2A3D', py: 1.5 }}>
                    {wo.title}
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    <Chip
                      label={wo.status}
                      size="small"
                      sx={{
                        height: 24,
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        bgcolor: `${wo.statusColor}15`,
                        color: wo.statusColor,
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ py: 1.5 }}>
                    <Chip
                      label={wo.priority}
                      size="small"
                      sx={{
                        height: 24,
                        fontSize: '0.6875rem',
                        fontWeight: 600,
                        bgcolor: `${wo.priorityColor}15`,
                        color: wo.priorityColor,
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.8125rem', color: '#4B5563', py: 1.5 }}>
                    {wo.assignedTo}
                  </TableCell>
                  <TableCell sx={{ fontSize: '0.8125rem', color: '#4B5563', py: 1.5 }}>
                    {wo.dueDate}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default WorkOrdersSection;
